@if (filteredIncidents().length > 0) {
    <hr class="divider" />
    <h1>Past incidents</h1>
    <div class="timeline-container">
        <div class="timeline-top"></div>
        <div class="timeline">
            @for (incident of filteredIncidents(); track incident.id) {
                <div class="vertical-line"></div>
                <div class="horizontal-line"><hr /></div>
                <div>
                    <app-incident
                        [incident]="incident"
                        [inTimeline]="true"
                        (notify)="onIncidentNotify($event)"
                    >
                    </app-incident>
                </div>
            }
            <div class="vertical-end"></div>
        </div>
    </div>
} @else {
    <h1 style="margin-top: 9rem">No past incidents</h1>
}
